module.exports = __webpack_public_path__ + "static/img/rage_strike-quests@2x.592fda75.png";